<template>
  <div class="phone_head">
    <div class="nav_bar">
      <!--      logo图片需要修改-->
      <router-link to="/">
        <img src="http://static.ilongyuan.cn/ld/dragonest/images_mobile/logo_black.png" alt="logo">
      </router-link>
      <!--      导航栏按钮设置-->
      <div class="menu" @click="changeMenu">
        <div :class="{top_line:isTop}" />
        <div :class="{middle_line:isMiddle}" />
        <div :class="{bottom_line:isBottom}" />
      </div>
    </div>
    <div v-show="isMenu" :class="{show:isShow}">
      <template v-for="(item,i) in showTitle">
        <div :key="i">
          <a v-if="item.u && item.u.indexOf('http:') >= 0" :href="item.u">
            <div :key="i">{{ item.n }}<hr></div>
          </a>
          <router-link v-else :to="item.u ? item.u : ''">
            <div :key="i">{{ item.n }}<hr></div>
          </router-link>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { get_head_data } from '@/api'

export default {
  name: 'PhoneHead',
  data() {
    return {
      // 是否显示游戏产品等
      isMenu: false,
      isTop: false,
      isMiddle: false,
      isBottom: false,
      isShow: false,
      showTitle: ['游戏产品', '精英招聘', '客服中心', '用户中心', '关于我们']
    }
  },
  created() {
    get_head_data().then(d => {
      const data = d.d
      const l = data.length
      this.showTitle.length = l
      for (let i = 0; i < l; i++) {
        this.showTitle.splice(i, 1, data[i])
      }
    })
  },
  methods: {
    // menu按钮点击后显示或者消失
    changeMenu() {
      this.isTop = !this.isTop
      this.isMiddle = !this.isMiddle
      this.isBottom = !this.isBottom
      this.isShow = !this.isShow
      this.isMenu = this.isMenu === false
    }
  }
}
</script>

<style lang="scss" scoped>
.phone_head{
  .nav_bar {
    height: 64PX;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 55px;

    img {
      width: 95PX;
      height: 35PX;
    }

    .menu {
      padding-right: 85px;

      div {
        width: 30PX;
        height: 4PX;
        background-color: #000000;
        margin-top: 4PX;
      }

      .top_line {
        transform: rotate(45deg) translate(5PX,7PX);
        /*transition: 0.3s ease-in-out 0.3s;*/

      }

      .middle_line {
        opacity: 0;
        transform: translateX(10px);
      }

      .bottom_line {
        transform: rotate(-45deg) translate(4PX,-6PX);
        /*transition: 0.3s ease-in-out 0.3s;*/
      }
    }
  }

  .show {
    transition-delay: 0.3s;
    transition: 0.3s ease-in-out;
    position: absolute;
    top: 150px;
    left: 0;
    z-index: 999;
    background: rgba(255,255,255,0.8);
    height: 370PX;
    width: 100%;
    padding: 25PX 45PX;
    display: flex;
    justify-content: space-around;
    flex-direction: column;

    div{
      list-style: none;
      font-size: 46px;
      font-weight: 100;
      margin: 5PX;
      hr {
        margin-top: 45px;
        border: 0.1px solid rgba(0,0,0,0.1);
      }
    }
  }
}
</style>
